<template>
    <div class="Board-page">
        <div class="ticker">
            <div class="ticker-track">
                <div class="ticker-group">
                    <span v-for="(item, idx) in tickerItems" :key="'a-'+idx">{{ item }}</span>
                </div>
                <div class="ticker-group" aria-hidden="true">
                    <span v-for="(item, idx) in tickerItems" :key="'b-'+idx">{{ item }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { allTicker, bitUsdtPrice, parseBitUsdtPrice } from '@/api';
export default {
  name: 'Board',
  data() {
    return { tickerItems: [] };
  },
  mounted() {
    this.loadTickerData();
  },
  methods: {
    async loadTickerData() {
      try {
        const [tickerRes, bitPriceRes] = await Promise.all([allTicker(), bitUsdtPrice()]);
        const raw = typeof tickerRes === 'string' ? (() => { try { return JSON.parse(tickerRes) } catch { return {} } })() : tickerRes;
        let list = [];
        if (Array.isArray(raw)) list = raw;
        else if (Array.isArray(raw?.data)) list = raw.data;
        else if (Array.isArray(raw?.data?.list)) list = raw.data.list;
        else if (Array.isArray(raw?.list)) list = raw.list;
        else {
          const candidates = [
            ...Object.values(raw || {}).filter(Array.isArray),
            ...Object.values((raw || {}).data || {}).filter(Array.isArray),
          ];
          if (candidates.length) list = candidates.flat();
          else {
            const values = Object.values((raw?.data ?? raw) || {});
            const looksLikeTicker = item => item && (item.market || item.symbol || item.pair) && (item.last !== undefined || item.price !== undefined || item.close !== undefined);
            list = values.filter(looksLikeTicker);
          }
        }
        const bitPrice = parseBitUsdtPrice(bitPriceRes);
        const filtered = list.filter(item => {
          const market = String(item?.market ?? item?.symbol ?? item?.pair ?? '').toUpperCase();
          const symbol = market.replace(/USDT$/i, '');
          return symbol === 'BIT' || symbol === 'KW';
        });
        const source = filtered.length ? filtered : list;
        const mapped = source.map(item => {
          const market = String(item?.market ?? item?.symbol ?? item?.pair ?? '').toUpperCase();
          const symbol = market.replace(/USDT$/i, '');
          const last = symbol === 'BIT' ? bitPrice : (item?.last ?? item?.price ?? item?.close ?? '');
          //const changeVal = item?.priceChangePercent ?? item?.changePercent ?? item?.pct ?? '';
          //const changeText = changeVal === '' ? '' : `（${String(changeVal).includes('%') ? changeVal : `${changeVal}%`}）`;
          return `${symbol}/USDT ${last}`;
        });
        const minCount = 40;
        const repeats = Math.ceil(minCount / Math.max(mapped.length, 1));
        this.tickerItems = Array.from({ length: repeats }).flatMap(() => mapped);
      } catch (e) {
        console.error('loadTickerData failed:', e);
        this.tickerItems = [];
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.Board-page {
    background-image: url('../assets/Board.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 100vw;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
    margin:  0;
    min-width: 1920px;
    z-index: 99;

    .ticker {
        overflow: hidden;
        .ticker-track {
            display: flex;
            width: max-content;
            animation: ticker-scroll 130s linear infinite;
        }
        .ticker-group {
            display: flex;
            align-items: center;
            white-space: nowrap;
            span {
                color: #141414;
                font-size: 18px;
                font-weight: 400;
                margin: 0 30px;
                font-family: 'Arial', sans-serif;
                &:nth-child(even) { color: #181717; }
            }
        }
    }
}

@keyframes ticker-scroll {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
}

@media (max-width: 768px) {
    .Board-page {
        height: 40px;
        
        .ticker-group {
            span {
                font-size: 14px;
                margin: 0 20px;
            }
        }
    }
}
</style>
